import React from 'react';
import { OnboardingStep } from '../../components/OnboardingTour';

export const GRID_ONBOARDING_KEY = 'onboarding:grid:v1';

/** Typed into the search by the tour to show what a result looks like; never added. */
export const ONBOARDING_DEMO_SYMBOL = 'FPT';

export const gridOnboardingSteps = (opts: {
    demoSearch: { start: () => void; stop: () => void };
}): OnboardingStep[] => [
    {
        title: 'Welcome to Grid Trading',
        description: (
            <>
                <p>The grid bot buys a fixed quantity each time the price steps down one level and sells it back one level higher, earning from the swings inside a price range.</p>
                <p style={{ marginBottom: 0 }}>Setup takes five steps: <b>symbol → grid settings → Save → Deposit → Place Grid</b>.</p>
            </>
        ),
    },
    {
        selector: '[data-tour="grid-symbols"]',
        title: '1. Add a symbol',
        description: 'Each button here is a symbol in this portfolio; a dashed button marked * is not saved yet. Click Add to search for a new one.',
        placement: 'bottom',
    },
    {
        selector: '.grid-add-instrument-modal .ant-modal-content',
        title: 'Search for a symbol',
        description: (
            <>
                Type a ticker and pick it from the results. Here the guide searched <b>{ONBOARDING_DEMO_SYMBOL}</b> as an example; it closes when you move on and nothing is added.
            </>
        ),
        placement: 'right',
        mask: false,
        onEnter: opts.demoSearch.start,
        onLeave: opts.demoSearch.stop,
    },
    {
        selector: '[data-tour="grid-chart"]',
        title: 'Price chart',
        description: 'Live candles for the selected symbol. Once the grid is set, its levels are drawn on the chart so you can see where the bot buys and sells.',
        placement: 'right',
    },
    {
        selector: '[data-tour="grid-params"]',
        title: '2. Set the grid',
        description: (
            <ul style={{ paddingLeft: 18, margin: 0 }}>
                <li><b>Upper Bound</b>: the top price of the grid.</li>
                <li><b>Grid Interval</b>: the price step between two levels.</li>
                <li><b>Number of Intervals</b>: how many levels sit below the upper bound.</li>
                <li><b>Quantity (per level)</b>: shares bought at each level.</li>
            </ul>
        ),
        placement: 'left',
    },
    {
        selector: '[data-tour="grid-save"]',
        title: '3. Save',
        description: 'Save stores the settings for this symbol (the button reads Update after edits). Saving does not place orders or move money.',
        placement: 'left',
    },
    {
        selector: '[data-tour="grid-capital"]',
        title: '4. Deposit capital',
        description: 'Deposit commits cash from your buying power to this symbol. The bot never spends more than what is deposited here. Withdraw returns idle cash and can sell positions if needed.',
        placement: 'left',
    },
    {
        selector: '[data-tour="grid-run"]',
        title: '5. Place Grid',
        description: 'Place Grid shows an order summary, then starts the bot. Stop lets you stop or restart just this symbol, or Stop All for the whole bot; stopping cancels unfilled orders. These buttons appear once the symbol is saved. Click Guide at the top right to replay this tour.',
        placement: 'left',
    },
];
